"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = () => ({
    cls1: {
        fill: 'none'
    },
    cls2: {
        isolation: 'isolate'
    },
    cls3: {
        fill: '#352594'
    },
    cls4: {
        fill: '#261b6b'
    },
    cls5: {
        fill: '#2e2182'
    },
    cls6: {
        fill: '#fff'
    },
    cls7: {
        clipPath: 'url(#clip-path)'
    },
    cls8: {
        fill: '#2f2182'
    },
    cls9: {
        fill: '#302286'
    },
    cls10: {
        fill: '#32238b'
    },
    cls11: {
        fill: '#2d207e'
    },
    cls12: {
        fill: '#2c1f7a'
    },
    cls13: {
        fill: '#2a1e76'
    },
    cls14: {
        fill: '#291d71'
    },
    cls15: {
        fill: '#271c6d'
    },
    cls16: {
        clipPath: 'url(#clip-path-2)'
    },
    cls17: {
        clipPath: 'url(#clip-path-3)'
    },
    cls18: {
        clipPath: 'url(#clip-path-4)'
    },
    cls19: {
        clipPath: 'url(#clip-path-5)'
    }
});
//# sourceMappingURL=icon.style.js.map